import React, { useRef, useState, useEffect } from "react";
import { FaCloudUploadAlt, FaTimes } from "react-icons/fa";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const Cover_photo = ({ currentPhoto, fetchUser }) => {
    const [file, setFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const fileInputRef = useRef(null);

    const storedUser = JSON.parse(secureLocalStorage.getItem("auth_data")) || {};
    const userId = storedUser.id || "";

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);

    const BASE_URL = "https://buzzinguniverse.com/backend/";
    const hasCover = currentPhoto && currentPhoto !== BASE_URL;

    const handleRemoveCover = async (e) => {
        e.target.classList.add("loadin");
        try {
            const formData = new FormData();
            formData.append("id", userId);
            formData.append("remove_cover_photo", "1");
            const response = await axios.post(
                "https://buzzinguniverse.com/backend/api/update-user",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            if (response.status === 200) {
                if (fetchUser) fetchUser();
                else window.location.reload();
                setMessage("Cover photo removed successfully!");
                setMessageType("success");
            } else {
                throw new Error("Unexpected response");
            }
        } catch (error) {
            setMessage("Failed to remove cover photo.");
            setMessageType("error");
        }
        e.target.classList.remove("loadin");
    };

    useEffect(() => {
        return () => {
            if (previewImage) {
                URL.revokeObjectURL(previewImage);
            }
        };
    }, [previewImage]);

    const resizeImageForCover = (file) => {
        return new Promise((resolve) => {
            const MAX_WIDTH = 1920;
            const MAX_HEIGHT = 640;
            const img = new Image();
            const url = URL.createObjectURL(file);
            img.onload = () => {
                URL.revokeObjectURL(url);
                let { width, height } = img;
                const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height, 1);
                width = Math.round(width * ratio);
                height = Math.round(height * ratio);
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob) => {
                    resolve(new File([blob], file.name, { type: 'image/jpeg' }));
                }, 'image/jpeg', 0.85);
            };
            img.src = url;
        });
    };

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const resized = await resizeImageForCover(selectedFile);
            setFile(resized);
            if (previewImage) {
                URL.revokeObjectURL(previewImage);
            }
            setPreviewImage(URL.createObjectURL(resized));
        }
    };

    const handleUpload = async (e) => {
        e.target.classList.add("loadin");
        if (!file) {
            setMessage("Please select an image first!");
            setMessageType("error");
            e.target.classList.remove("loadin");
            return;
        }

        if (!userId) {
            setMessage("User ID not found. Please log in again.");
            setMessageType("error");
            e.target.classList.remove("loadin");
            return;
        }

        const formData = new FormData();
        formData.append("id", userId);
        formData.append("cover_photo", file);

        try {
            const response = await axios.post(
                "https://buzzinguniverse.com/backend/api/update-user",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                window.location.reload();
                setMessage("Image uploaded successfully!");
                setMessageType("success");
            } else {
                throw new Error("Invalid response format");
            }
        } catch (error) {
            console.error("Upload failed:", error);
            setMessage("Failed to upload image.");
            setMessageType("error");
        }
        e.target.classList.remove("loadin");
    };

    return (
        <div className="image-upload-container">
            {hasCover && !previewImage && (
                <div className="current-photo-preview text-center mb-3">
                    <img src={currentPhoto} alt="Current Cover" style={{ width: '100%', maxHeight: 180, objectFit: 'cover', borderRadius: 8, border: '2px solid #ddd' }} />
                    <div className="mt-2">
                        <button onClick={handleRemoveCover} style={{ background: '#dc3545', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', cursor: 'pointer' }}>
                            <FaTimes style={{ marginRight: 5 }} /> Remove Cover Photo
                        </button>
                    </div>
                    {message && !previewImage && (
                        <p className={`message ${messageType === "success" ? "success-message" : "error-message"}`}>{message}</p>
                    )}
                </div>
            )}
            {!previewImage && (
                <div className="file-upload-wrapper">
                    <label className="file-upload-box mb-0">
                        <input
                            type="file"
                            accept=".png, .jpeg, .jpg, .webp"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className="hidden"
                            hidden
                        />
                        <div className="upload-content">
                            <FaCloudUploadAlt className="upload-icon" />
                            <h5 className="mb-2">Upload your Cover picture</h5>
                        </div>
                    </label>
                </div>
            )}
            {previewImage && (
                <div className="profile-image-preview mt-4 text-center">
                    <img
                        src={previewImage}
                        alt="Profile Preview"
                    />
                    <button
                        onClick={handleUpload}
                    >
                        Set Cover Picture
                    </button>
                    <button
                        onClick={() => {
                            setFile(null);
                            setPreviewImage(null);
                            setMessage(null);
                        }}
                    >
                        <FaTimes /> Remove
                    </button>
                    {message && (
                        <p className={`message ${messageType === "success" ? "success-message" : "error-message"}`}>
                            {message}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Cover_photo;
